import {makeStyles} from 'tss-react/mui';

const useStyles = makeStyles()((theme, _params, classes) => ({
  node: {
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    width: '293px',
    height: '59px',
    padding: '5px',
    border: `${theme.palette.grey.grey200} 1px solid`,
    borderRadius: '12px',
    background: "linear-gradient(0deg, rgba(255, 255, 255, 0.50) 0%, rgba(255, 255, 255, 0.50) 100%), #F2F3F7",
    boxShadow: "0px 2px 5px 0px rgba(0, 0, 0, 0.07)",
  },
  originClient: {
/*    border: `${alpha(theme.palette.warning.warning400, 0.7)} 1px solid`,
    background: `${alpha(theme.palette.warning.warning100, 1)}`*/
  },
  originThirdParty: {
/*    border: `#abc9fb 1px solid`,
    background: '#abc9fb33'*/
  },
  originClientAndThirdParty: {
  /*  border: `#6d00cc 1px solid`,
    background: '#6d00cc33'*/
  },
  selectedNode: {
    position: 'relative',
    zIndex: 1,
    border: `${theme.palette.primary.primary400} 1px solid`,
    background: theme.palette.primary.primary100,
    boxShadow: `0 0 0 3px ${theme.palette.primary.primary300}`,
    borderRadius: '12px',
  },

  nodeWrapper: {
    width: '293px',
    height: '59px',
  },
  selectedNodeWrapper: {
    border: `0 0 0 3px ${theme.palette.primary.primary300}`,
    borderRadius: '15px'
  },
  nodeInfosWrapper: {
    display: 'flex',
    alignItems: 'center',

  },
  nodeInfos: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '10px',
  },
  attachedNodePoint: {
    position: 'absolute',
    top: 0,
    left: 'calc(50%)',
    transform: 'translate(-50%, -6px)',
    width: '9px',
    height: '9px',
    borderRadius: '50%',
    border: '1px solid white',
    backgroundColor: theme.palette.primary.primary500,
  },
  deleteIcon: {
    width: '16px'
  },
  nodeTitle: {
    fontSize: '14px',
    fontFamily:'Inter',
    fontWeight: 600,
    textAlign: 'left',
    maxWidth: '210px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  nodeButtons: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    marginTop: '20px'
  },
  moreDetails: {
    display: 'flex',
    width: 'fit-content',
    '& span':{
      fontSize: '12px',
      color: theme.palette.grey.grey400,
      textDecoration: 'none',
      '&:hover': {
        textDecoration: `underline`,
        textDecorationColor: theme.palette.grey.grey400,
      },
    }
  },
  togglerIcon:{
    position:'relative',
    top: '1px'
  },
  nodeAttributes: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-around',
    position: "relative",
    top: '-2px',
    background: 'white',
    height: 'fit-content',
    borderRadius: '4px',
    boxShadow: "0px 2px 5px 0px rgba(0, 0, 0, 0.07)",
    '& > :first-of-type': {
      borderBottom: `1px solid ${theme.palette.grey.grey300}`,
    }
  },
  nodeAttributeListWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  nodeAttributeDropDown: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.black.dark,
    width: '100%',
    padding: '12px 8px',
    fontSize: '12px',
    '&:hover': {
      backgroundColor: theme.palette.primary.primary100,
    },
    '& span': {
      marginLeft: '4px'
    }
  },
  openAttributes: {
    transform: 'rotate(90deg)',
  },
  nodeAttributeList: {
    display: 'flex',
    flexDirection: 'column',
    margin: '4px 0px 8px 0px'
  },
  archivedIcon: {
    position: 'absolute',
    right: '10px'
  },
  isArchived: {
    background: theme.palette.grey.grey100,
    border: `${theme.palette.grey.grey400} 1px solid`,
    boxShadow: `0 0 0 3px ${theme.palette.grey.grey300}`,
  }
}));

export default useStyles;
